module.exports = __webpack_public_path__ + "img/bn_m(3).04f38e4d.png";